module.exports = __webpack_public_path__ + "img/document.86ff52a9.svg";